import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import Managed, { useManaged } from "../common/components/Managed";
import api from "../common/lib/api";
import { useError, ErrorCallout } from "../common/components/Errors";
import { Intent, Button } from "@blueprintjs/core";
import AsyncButton from "../common/components/AsyncButton";
import qs from "qs";

const AVAILABLE_LOCALES = ["au", "nz", "png", "za"];

const beepAudio = new Audio("/audio/packing/beep.wav");
const bleepAudio = new Audio("/audio/packing/bleep.wav");

export default function Page() {
  const { saleOrderId } = useParams();
  const history = useHistory();
  const [state, setState, setError] = useManaged();
  const [scannerInput, setScannerInput] = useState("");
  const { errors: scanErrors, handleError: handleScanErrors } = useError();
  const query = window.location.search
    ? qs.parse(window.location.search.substring(1))
    : {};
  const { deviceLocale: deviceLocaleParam } = query;

  const { data } = state;

  const {
    deviceLocale: deviceLocaleHint,
    deviceScanned,
    deviceNeeds,
    deviceNeedsTotal,
    deviceNeedsSatisfied,
    shippingScanned,
    shippingNeeds,
    shippingNeedsSatisfied,
    shippingNeedsTotal,
    couponScanned,
    couponNeeds,
    couponNeedsSatisfied,
    couponNeedsTotal,
    shippingMethod,
  } = data || {};

  const deviceLocale = deviceLocaleParam || deviceLocaleHint;

  console.log(window.location);

  const devicesDone =
    !deviceNeedsTotal ||
    (deviceNeedsSatisfied && deviceNeedsTotal === deviceNeedsSatisfied);
  const shippingDone =
    !shippingNeedsTotal || shippingNeedsTotal === shippingNeedsSatisfied;
  const couponDone =
    !couponNeedsTotal || couponNeedsTotal <= couponNeedsSatisfied;

  const packingDone = devicesDone && shippingDone && couponDone;

  console.log(data);

  console.log(devicesDone, shippingDone, packingDone);

  async function load(saleOrderId, setState, setError) {
    try {
      const { data } = await api.get(`/sale-orders/pack/${saleOrderId}`);
      const deviceScanned = {};
      const shippingScanned = {};
      const couponScanned = {};
      let deviceNeedsSatisfied = 0;
      let shippingNeedsSatisfied = 0;
      let couponNeedsSatisfied = 0;
      setState({
        ...data.data,
        deviceScanned,
        deviceNeedsSatisfied,
        shippingScanned,
        shippingNeedsSatisfied,
        couponScanned,
        couponNeedsSatisfied,
      });
    } catch (e) {
      setError(e);
    }
  }

  async function onScannerInput(input) {
    try {
      const inputStr = input.trim();

      if (inputStr.match(/ /)) {
        for (const inputStrItem of inputStr.split(/\s+/g)) {
          if (inputStrItem) {
            try {
              await process(inputStrItem);
            } catch (e) {
              handleScanErrors(e);
            }
          }
        }
      }

      if (inputStr) {
        await process(inputStr);
      }
    } catch (e) {
      handleScanErrors(e);
    }

    async function process(inputStr) {
      if (!devicesDone) {
        await onDeviceScannerInput(inputStr);
      } else if (!shippingDone) {
        await onShippingScannerInput(inputStr);
      } else {
        await onCouponScannerInput(inputStr);
      }
    }
  }

  function scanInput(saleOrderId, scanType, allowAdditional = false) {
    return async function (input) {
      const {
        data: { data: scannedData },
      } = await api.get(`/sale-orders/pack/${saleOrderId}/${scanType}`, {
        params: {
          input: input,
          locale: deviceLocale,
          saleOrderId,
        },
      });
      const { type, barcode, label, count, couponsNeeded, meta } = scannedData;

      const itemScanned = (data || {})[`${scanType}Scanned`] || {};
      const itemNeeds = (data || {})[`${scanType}Needs`] || {};

      const scanned = itemScanned[type] || (itemScanned[type] = []);
      const needs = itemNeeds[type];

      if (
        scanned.find((sc) => sc.barcode === barcode) &&
        barcode !== "MYOB-ANTH3G" &&
        barcode !== "MYOB-ANTH4G" &&
        barcode !== "MYOB-DRMK"
      ) {
        throw new Error("Already Scanned " + barcode);
      }

      if ((!needs || scanned.length >= needs) && !allowAdditional) {
        throw new Error("Dont need a " + type + " " + label);
      }

      const update = {
        couponNeeds: data.couponNeeds,
        couponNeedsTotal: data.couponNeedsTotal,
      };
      if (couponsNeeded) {
        for (const [type, quantity] of Object.entries(couponsNeeded)) {
          update.couponNeeds[type] = update.couponNeeds[type] || 0;
          update.couponNeeds[type] += quantity;
          update.couponNeedsTotal += quantity;
        }
      }

      let satisfied = 1;
      scanned.push(scannedData);
      if (meta && meta === "fixed") {
        while (scanned.length < needs) {
          scanned.push(scannedData);
          satisfied += 1;
        }
      }

      setState((state) => ({
        ...state,
        [`${scanType}NeedsSatisfied`]:
          state[`${scanType}NeedsSatisfied`] + (count || satisfied),
        ...update,
      }));

      if (
        scanned.length &&
        (scanned.length % 10 === 0 || scanned.length === needs)
      ) {
        bleepAudio.play();
      } else {
        beepAudio.play();
      }
    };
  }

  const onDeviceScannerInput = scanInput(saleOrderId, "device");
  const onShippingScannerInput = scanInput(saleOrderId, "shipping", true);
  const onCouponScannerInput = scanInput(saleOrderId, "coupon");

  async function printPackingSlip() {
    try {
      const { data } = await api.get(
        "/sale-orders/item/" + saleOrderId + "/packing-slip",
        { responseType: "blob" }
      );
      const fileURL = URL.createObjectURL(data);
      window.open(fileURL);
    } catch (e) {
      alert(e);
    }
  }

  async function onSubmitOrder(request) {
    try {
      await api.post(`/sale-orders/pack/${saleOrderId}`, request);

      await printPackingSlip();

      window.location.href = "/sale-order/" + saleOrderId;
    } catch (e) {
      handleScanErrors(e);
    }
  }

  useEffect(() => {
    load(saleOrderId, setState, setError);
  }, [saleOrderId, setError, setState]);

  const devices = Object.entries(deviceNeeds || {}).sort((a, b) =>
    a[0] > b[0] ? 1 : -1
  );
  const shipping = Object.entries(shippingNeeds || {});
  const coupon = Object.entries(couponNeeds || {});
  return (
    <>
      <Managed state={state}>
        {data && (
          <>
            <div style={{ float: "right" }}>
              <select onChange={e => {
                const value = e.target.value;
                history.push({
                  search: '?deviceLocale=' + value
                })
              }}>
                <option disabled selected>Change Locale</option>
                {AVAILABLE_LOCALES.map(locale => <option>{locale}</option>)}
              </select>
            </div>
            <h1>{`Pack ${data.companyName} Sale Order [${deviceLocale}]`}</h1>
            {devices.map(([type, quantity]) => {
              const typeSerials = (deviceScanned || {})[type] || [];

              return (
                <div key={type}>
                  <h2>
                    {type}
                    <small>x{quantity}</small>
                  </h2>
                  <ul>
                    {typeSerials
                      .filter((x, xi, xx) => xx.indexOf(x) === xi)
                      .map((serial) => (
                        <li key={serial.barcode}>
                          {serial.display}
                          {Boolean(
                            serial.warnings && serial.warnings.length
                          ) && (
                            <ul>
                              {serial.warnings.map((warning) => (
                                <li key={serial.barcode + warning}>
                                  <small style={{ color: "red" }}>
                                    {warning}
                                  </small>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                  </ul>
                  {typeSerials.length < quantity &&
                    `${quantity - typeSerials.length} remaining`}
                </div>
              );
            })}
            {Boolean(devicesDone) &&
              shipping.map(([type, quantity]) => {
                const typeSerials = (shippingScanned || {})[type] || [];
                return (
                  <div key={type}>
                    <h3>{type}</h3>
                    <ul>
                      {typeSerials.map((serial) => (
                        <li key={serial.trackingCode}>
                          {serial.label} {serial.trackingCode}
                          {Boolean(
                            serial.warnings && serial.warnings.length
                          ) && (
                            <ul>
                              {serial.warnings.map((warning) => (
                                <li key={serial.barcode + warning}>
                                  <small style={{ color: "red" }}>
                                    {warning}
                                  </small>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            {Boolean(shippingDone) &&
              coupon.map(([type, quantity]) => {
                const typeSerials = (couponScanned || {})[type] || [];
                return (
                  <div key={type}>
                    <h3>{type}</h3>
                    <ul>
                      {typeSerials.map((serial) => (
                        <li key={serial.trackingCode}>
                          {serial.label} {serial.trackingCode}
                          {Boolean(
                            serial.warnings && serial.warnings.length
                          ) && (
                            <ul>
                              {serial.warnings.map((warning) => (
                                <li key={serial.barcode + warning}>
                                  <small style={{ color: "red" }}>
                                    {warning}
                                  </small>
                                </li>
                              ))}
                            </ul>
                          )}
                        </li>
                      ))}
                    </ul>
                    {typeSerials.length < quantity &&
                      `${
                        quantity - typeSerials.reduce((a, b) => a + b.count, 0)
                      } remaining`}
                  </div>
                );
              })}

            {!packingDone && (
              <h3>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    onScannerInput(scannerInput);
                    setScannerInput("");
                  }}
                >
                  <input
                    value={scannerInput}
                    onChange={(e) => {
                      setScannerInput(e.target.value);
                    }}
                    placeholder="Please enter barcode here"
                    autoFocus={true}
                  />
                </form>
              </h3>
            )}
            <br />
            <p>
              <AsyncButton
                intent={Intent.PRIMARY}
                disabled={!packingDone}
                onClick={async () => {
                  const { shippingScanned, deviceScanned } = data;
                  const request = {
                    deviceLocale,
                    shippingScanned: Object.values(shippingScanned)
                      .reduce((a, b) => a.concat(b), [])
                      .map((x) => x.barcode),
                    deviceScanned: Object.values(deviceScanned)
                      .reduce((a, b) => a.concat(b), [])
                      .map((x) => x.barcode),
                    couponScanned: Object.values(couponScanned)
                      .reduce((a, b) => a.concat(b), [])
                      .map((x) => x.barcode),
                  };

                  await onSubmitOrder(request);
                }}
              >
                Submit
              </AsyncButton>
              {shippingMethod !== "Other" && shippingMethod !== "Pick Up" && (
                <Button
                  disabled={!packingDone}
                  onClick={() => {
                    setState({
                      ...data,
                      shippingNeedsTotal: shippingNeedsTotal + 1,
                    });
                  }}
                >
                  Add Additional Shipping
                </Button>
              )}
            </p>
            <ErrorCallout errors={scanErrors} />
          </>
        )}
      </Managed>
    </>
  );
}
